import e, { Component as t } from "react";
import { FormLabel as r } from "../Label/FormLabel.js";
import { componentName as n } from "../../../utils/bem/index.js";
function o(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function c(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function a(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function i(e) {
  return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function l(e, t) {
  return (l = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var u = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && l(e, t);
  }(b, t);
  var u,
    s,
    f,
    p = (u = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        r = i(b);
      if (u) {
        var n = i(this).constructor;
        t = Reflect.construct(r, arguments, n);
      } else t = r.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : o(this);
    });
  function b() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, b), e = p.apply(this, arguments), a(o(e), "_handleFieldChange", function (t) {
      t.persist(), e.props.onChange(t.target.checked, t);
    }), e;
  }
  return s = [{
    key: "render",
    value: function value() {
      var t,
        o,
        c = this.props,
        i = c.label,
        l = c.helpText,
        u = c.isRequired,
        s = c.disabled,
        f = c.className,
        p = c.value,
        b = c.autoFocus,
        y = c.name,
        h = c.fieldLabel,
        d = function (e, t) {
          if (null == e) return {};
          var r,
            n,
            o = function (e, t) {
              if (null == e) return {};
              var r,
                n,
                o = {},
                c = Object.keys(e);
              for (n = 0; n < c.length; n++) r = c[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var c = Object.getOwnPropertySymbols(e);
            for (n = 0; n < c.length; n++) r = c[n], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
          }
          return o;
        }(c, ["label", "helpText", "isRequired", "disabled", "className", "value", "autoFocus", "name", "fieldLabel"]),
        O = n("checkbox", f, {
          disabled: s,
          stateless: !0,
          valueEntered: !!p,
          valueMixed: "boolean" != typeof this.props.value && void 0 !== this.props.value
        });
      return e.createElement(r, {
        className: O,
        value: i,
        hint: l,
        isDisabled: s,
        isRequired: u
      }, e.createElement("div", {
        className: "checkbox__input-container qa-input-container"
      }, e.createElement("input", (t = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {},
            n = Object.keys(r);
          "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
          }))), n.forEach(function (t) {
            a(e, t, r[t]);
          });
        }
        return e;
      }({}, d), o = o = {
        ref: "stateless",
        checked: !0 === p,
        onChange: this._handleFieldChange,
        onKeyDown: this.props.onKeyDown,
        type: "checkbox",
        name: y,
        disabled: s,
        autoFocus: b
      }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : function (e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          r.push.apply(r, n);
        }
        return r;
      }(Object(o)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(o, e));
      }), t)), h && e.createElement("span", {
        className: "checkbox__field-label"
      }, h)));
    }
  }], c(b.prototype, s), f && c(b, f), b;
}(t);
a(u, "displayName", "CheckBoxStateless"), a(u, "defaultProps", {
  onChange: function onChange() {
    return 0;
  }
});
export { u as CheckBoxStateless };